<template>
    <div>
        <compFormEdit
            class="margin-top-15 margin-right-15"
            ref="editform"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1">
        </compFormEdit>
        <div class="color-error text-center">{{$t('fbb.account.cusdisacountrate_sure_copy', { defaultValue: '确认复制后，目标组织对应承运商服务、类型下原折扣率会被清除，请谨慎操作！' })}}</div>
        <div class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">{{$t('fbb.account.cusdisacountrate_sure', { defaultValue: "确认复制" })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: "取消" })}}</vButton>
        </div>
    </div>
</template>

<script>
import { HttpCopyDisacountRate } from '@/service/account';
import { HttpGetServiceList, HttpGetServiceProductList } from "@/service/fedex";
import { HttpOtherLogiServiceList,HttpGetCarrierGroupByOrg } from "@/service/carrieraccount";
import { HttpProductList } from '@mods/service/dictionary';
import { mapGetters } from 'vuex';
import mixin from "../mixin"
export default {
    mixins: [mixin],
    data(){
        return{
            formData:{
                orgIds:[]
            },
            groupServiceList:[],
            groupList:[],
            showline:false,
            showline2:false,
            sourproductList:[],
            tarproductList:[],
        }
    },
    components: {
		compFormEdit: () => import("@components/templates/formedit"),
	},
    computed:{
        ...mapGetters('dictionary', ['getNextOrgList','getCarrierServiceList','getCountryList']),
        getBase(){
            return [
                {
                    label: this.$t('fbb.carrier.extra_source', { defaultValue: '来源组织' }),
                    key: "sourceOrgId",
                    tag:'Select',
                    options:this.getNextOrgList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(val){
                                // this.getOrgGroupList(val);
                                this.getProduct(val)
                                HttpGetServiceList({
                                // HttpGetCarrierGroupByOrg({
                                    // contextId:global.SYSID,
                                    customerId: val,
                                }).then(
                                    (res) => {
                                        this.groupList = res.data.map(item => {
                                            return {
                                                value: item.id,
                                                label: item.carrierGroupCode,
                                                attach: {
                                                    ...item
                                                },
                                            };
                                        });
                                    },
                                    (err) => {
                                        this.$VMessage.error(err.message);
                                    }
                                );
                            }
                        }
                    },
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_source_type', { defaultValue: '来源类型' }),
                    key: "sourceDiscountType",
                    tag:'Select',
                    options:this.getDisacountType,
                    on:{
                        'on-change':(val)=>{
                            this.showItem(val);
                            this.resetRegionCode()
                        }
                    }
                },
                {
                    label:this.$t('erp.channelbase.country',{defaultValue:'国家'}),
                    tag:'Select',
                    key:'regionCode',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.value,
                            label:item.label
                        }
                    }),
                    show:this.formData.sourceDiscountType===10,
                },
                {
                    label: this.$t('fbb.account.sourceLineId', { defaultValue: '来源项目' }),
                    key: "sourceLineId",
                    tag:'Select',
                    options:this.sourproductList.map(item =>{
                        return {
                            label:item.name,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true
                    },
                    show:this.showline
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: "物流产品",
                    key: "sourceGroupId",
                    tag: 'Select',
                    options:this.groupList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(val){
                                // this.getGroupServiceList(val);
                                HttpGetServiceProductList({
                                // HttpOtherLogiServiceList({
                                    contextId:global.SYSID,
                                    carrierGroupId: val,
                                    orgId: this.formData.sourceOrgId,
                                }).then(
                                    (res) => {
                                        this.groupServiceList = res.data.map(item => {
                                            return {
                                                value: item.id,
                                                label: item.code,
                                                attach: {
                                                    ...item
                                                },
                                            };
                                        });
                                        this.getRegionCountry(val)
                                    },
                                    (err) => {
                                        this.$VMessage.error(err.message);
                                    }
                                );
                            }
                        }
                    },
                    show:this.formData.sourceDiscountType!=10,
                },
                {
                    label: this.$t('fbb.carrier.extra_source_service', { defaultValue: '来源承运商服务' }),
                    key: "sourceCarrierServiceId",
                    tag:'Select',
                    options:this.groupServiceList,
                    props:{
                        filterable:true
                    },
                    // on:{
                    //     'on-change':(val)=>{
                    //         this.getRegionCountry(val)
                    //     }
                    // },
                    show:this.formData.sourceDiscountType!=10,
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    query:true,
                    tag: "div",
                    children: (h) => {
                        const region=this.getCountryList.filter(item=>item.value===this.formData.regionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                    show:this.formData.sourceDiscountType!=10,
                },
                {
                    label: this.$t('fbb.carrier.extra_target_org', { defaultValue: '目标组织' }),
                    key: "orgIds",
                    tag:'Select',
                    options:this.getNextOrgList,
                    props:{
                        filterable:true,
                        multiple:this.formData.sourceDiscountType==21||this.formData.sourceDiscountType==31 ? false : true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(this.formData.sourceDiscountType==21||this.formData.sourceDiscountType==31){
                                this.targeProduct(val)
                            }
                        }
                    }
                },
                {
                    label: this.$t('fbb.account.targetLineId', { defaultValue: '目标项目' }),
                    key: "lineId",
                    tag:'Select',
                    options:this.tarproductList.map(item =>{
                        return {
                            label:item.name,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true,
                        multiple:true,
                    },
                    show:this.showline2
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_target_carrier', { defaultValue: '目标承运商服务' }),
                    key: "carrierServiceId",
                    tag:'Select',
                    options:this.groupServiceList,
                    props:{
                        filterable:true
                    },
                    show:this.formData.sourceDiscountType!=10,
                },
            ]
        }
    },
    methods:{
        resetRegionCode(){
            this.formData.regionCode='';
        },
        getRegionCountry(val){
            const groupService=this.groupList.filter(item=>{
                return item.value==val
            })
            this.formData.regionCode=groupService[0]?groupService[0].attach.regionCode:''
        },
        showItem(val){
            switch(val){
                case 21: this.showline = true ;this.showline2 = true; break;
                case 31: this.showline = true ;this.showline2 = true; break;
                default : this.showline = false ;this.showline2 = false; break;
            }
            this.formData.orgIds = [];
            this.formData.lineId = []
        },
        getProduct(val){
            HttpProductList({
                contextId:val
            }).then(res=>{
                // console.log(res.data)
                this.sourproductList = res.data
            })
        },
        targeProduct(val){
            this.formData.orgIds = [];
            this.formData.orgIds.push(val)
            HttpProductList({
                contextId:val
            }).then(res=>{
                this.tarproductList = res.data
            })

        },
        submit(){
            HttpCopyDisacountRate({
                ...this.formData
            }).then(res=>{
                this.$VMessage.success(res.data)
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
        cancel(){
            this.$emit('on-close')
        },
    },
}
</script>

